<template>
  <DBox
    :id="'cmp-licencing-licence-sidewindow-tracks'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_new')}`"
    @add_click="onAdd"
    :rightMenu="[...rightMenu]"
    @menuClick="onRightMenuClick"
  >
    <NTable
      class="dbox1"
      id="licencing-licence-sidewindow-tracks"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td  v-bind="tdcon('asset_type')">
            <span >{{ item["asset_type"] }}</span>
          </td>
          <td v-bind="tdcon('identifier')">
            <span class="ut-link ut-text-accent5 txtov" @click="onIdentifierClick(item)" >{{ item["identifier"] }}</span>
          </td>

          <td v-bind="tdcon('artist')">
            <span>{{ item["artist"] }}</span>
          </td>
          <td v-bind="tdcon('title1')">
            <span>{{ item["title"] }}</span>
          </td>
          <td v-bind="tdcon('licensors')">
            <span>{{ item["licensors"] }}</span>
          </td>
          <td v-bind="tdcon('options')">
            <div class="dt-icon-container">
              <img
                @click.stop="e => deleteAsset(item)"
                src="static/icons/delete.svg"
                class="dt-icon v5 s1"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { ConfirmationService } from "../../../../dt-plugins/confirmation/confirmation.service";
import { productsListLDTRoutes, releasesListLDTRoutes, tracksListLDTRoutes } from "../../../catalog/router/routes";
import { licenceService } from "../../services/licence.service";

export default {
  props: {
    selectedLicenceDetails: {
      type: Object
    }
  },
  components: {
    NTable,
    DBox
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      })
    };
  },
  computed: {
    Headers: function() {
      // return [
      //   createTableHeader("artist", {}),
      //   createTableHeader("title1", { text: this.$t("title") }),

      //   createTableHeader("version", {}),
      //   createTableHeader("isrc", {}),
      //   createTableHeader("licensors", {}),
      //   createTableHeader("options", { text: false, mw: 40 })
      // ];

      return [
        createTableHeader("asset_type", {}),
        createTableHeader("identifier", {  }),

        createTableHeader("artist", {}),
        createTableHeader("title1", { text: this.$t("title") }),
        createTableHeader("licensors", {}),
        createTableHeader("options", { text: false, mw: 30 })
      ];
    },

    licence_id: function () {
      return this.selectedLicenceDetails.licence.licence_id;
    },

    list: function() {
      return this.selectedLicenceDetails.tracks || [];
    },
    rightMenu:function(){
      return  [
        {
          text: this.$t('auto_fill_release'),
          value: 'auto_fill_release',
        },
        {
          text: this.$t('auto_fill_product'),
          value: 'auto_fill_product',
        },
      ]


      
    },
  },

  methods: {
    getConcatTitle:function(item){
      if(item.version && item.version.length>0){
        return `${item['title']} (${item['version']})`;
      }

      return item['title']||'';
    },
    deleteAsset: function(item) {
      ConfirmationService.create({
        subject: `${this.$t("delete_confirmation_msg")} ${this.$t("asset")}`,
        model: true,
        width: 500,
        completed: res => {
          switch (res) {
            case "OK": {
              this.$emit("delete", {
                licence_id: item.licence_id,
                licence_track_id: item.licence_track_id
              });
              break;
            }
            default: {
            }
          }
        }
      });
    },

    onAdd: function() {

      console.log(this.licence_id,":::::::::::")

      this.$router.push({
        ...this.$route,
        query: {
          modal: "select_asset_modal",
          licence_id: this.licence_id
        }
      });
    },
    onRightMenuClick:async function(menu) {
      console.log(menu)

      let action = '';
      switch(menu) {
        case 'auto_fill_release': {
          //await licenceService.autofillFromReleases(this.licence_id);
          action = 'autofill_from_releases';
          break;
        }
        case 'auto_fill_product': {
          //await licenceService.autofillFromProducts(this.licence_id);
          action = 'autofill_from_products';
          break;
        }


      }

      await licenceService.autofillRelatedAsset(this.licence_id,action);
      this.$emit('refresh');
    },

    onIdentifierClick: function(item) {
      console.log(item);

      const primaryKeyDict = [
          { type:'Product' , primary_key:'product_id' , LDTHost:productsListLDTRoutes },
          { type:'Track' , primary_key:'track_id'  , LDTHost:tracksListLDTRoutes},
          { type:'Release' , primary_key:'release_id' ,LDTHost:releasesListLDTRoutes }

        ];

      const primary_key = primaryKeyDict.find(x=>x.type==item.asset_type).primary_key;
      
      const LDTHost = primaryKeyDict.find(x=>x.type==item.asset_type).LDTHost;
      console.log("L::::::::::::::::::::",LDTHost,"::::::::::::",primary_key);

      this.$router.push({
        name: LDTHost.names.tab,
        params: {
          [primary_key]: item.external_id,
          tab: "overview"
        }
      });
    }
  }
};
</script>
